import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export const Services = () => {
  const { t } = useTranslation("landing");
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add("is-visible");
          observer.unobserve(section);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div id="serv" ref={sectionRef}>
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{t("services.title")}</h2>
              <p>{t("services.paragraph")}</p>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 d-flex">
            <img src="img/team.png" className="img-responsive scale-x" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const LdServices = () => {
  const { t } = useTranslation("landing");
  const line1 = t("ldServices.line", { returnObjects: true }) || [];
  const line2 = t("ldServices.line2", { returnObjects: true }) || [];
  const line3 = t("ldServices.line3", { returnObjects: true }) || [];
  const line4 = t("ldServices.line4", { returnObjects: true }) || [];

  const allItems = [...line1, ...line2, ...line3];

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const rows = chunkArray(allItems, 3);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    document.querySelectorAll("#services .card, #services .card-wide").forEach((card) => {
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div id="services" className="text-center" style={{ paddingBottom: "100px" }}>
      <div className="container">
        <div className="section-title">
          <h2>{t("ldServices.title")}</h2>
        </div>

        {rows.length === 0 ? (
          <div className="no-services">{t("ldServices.noServices")}</div>
        ) : (
          rows.map((row, rowIndex) => (
            <div key={`row-${rowIndex}`} className="row">
              {row.map((d, i) => {
                const positionClass =
                  i === 0 ? "slide-left" : i === 1 ? "slide-up" : "slide-right";
                const delayClass = `delay-${i}`;
                const key = (d && (d.name || d.id)) || `service-${rowIndex}-${i}`;

                return (
                  <div key={`${key}-${rowIndex}-${i}`} className="col-md-4 col-xs-12">
                    <div className={`card ${positionClass} ${delayClass}`}>
                      <i className={d.icon}></i>
                      <div className="service-desc">
                        <h3>{d.name}</h3>
                        <p>{d.text}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))
        )}

        {line4.length > 0 && (
          <div className="row" style={{ marginTop: "30px" }}>
            {line4.map((d, i) => {
              const positionClass =
                i === 0 ? "slide-left" : i === 1 ? "slide-up" : "slide-right";
              const delayClass = `delay-${Math.min(i, 2)}`;
              const key = (d && (d.name || d.id)) || `line4-${i}`;

              return (
                <div key={`line4-${key}-${i}`} className="col-md-4 col-xs-12">
                  <div className={`card ${positionClass} ${delayClass}`}>
                    <i className={d.icon} aria-hidden="true" />
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
